import { StatusData } from "@fairfleet/geotab";
import Box from "@mui/material/Box";
import { useState } from "react";
import TellTale from "./TellTale";
import TellTalesLegend from "./TellTalesLegend";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import TellTaleType from "@/models/TellTaleType";

interface TellTaleComponentProps {
  displayTellTales: TellTaleType[];
  tellTaleData: StatusData[];
}

export default function TellTalesComponent(props: TellTaleComponentProps) {
  const { displayTellTales, tellTaleData } = props;
  const { hideOldData } = useDataGridSettings();
  // By default hide 7: N/A
  const [hiddenStatuses, setHiddenStatuses] = useState<number[]>([7]);

  const toggleHideStatus = (status: number) => {
    setHiddenStatuses(prevHidden =>
      prevHidden?.includes(status) ? prevHidden.filter(s => s !== status) : [...prevHidden, status],
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        width: "100%",
      }}
    >
      <TellTalesLegend onToggleStatus={toggleHideStatus} hiddenStatuses={hiddenStatuses} />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {displayTellTales.map(t => {
          const data = tellTaleData.find(d => d.diagnostic.id === t.id);
          const status = data?.data ?? 7;
          if (hiddenStatuses.includes(status)) return null;

          return (
            <TellTale
              key={t.id}
              iso={t.iso}
              name={t.name}
              status={status}
              date={data?.dateTime}
              hideOldData={hideOldData}
            />
          );
        })}
      </Box>
    </Box>
  );
}
